export const serverEndpoint = process.env.REACT_APP_SERVER_ENDPOINT;